//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { AssetFamilyPaginationResult } from './models/AssetFamilyPaginationResult';
import type { AssetNaturePaginationResult } from './models/AssetNaturePaginationResult';
import { Utilities } from './Utilities';

export class ReferentialsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getAssetNatures: (
			famillyId?: number,
        ): string => {
            let clientRequestUrl = '/api/v1/referentials/asset-natures?';
            if (famillyId === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('famillyId'));
            } else if (famillyId !== undefined) {
                clientRequestUrl += `famillyId=${encodeURIComponent(String(famillyId))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAssetFamilies: (): string => {
            let clientRequestUrl = '/api/v1/referentials/asset-families';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get asset natures
     * @param famillyId (optional) 
     * @return OK
     */
    async getAssetNatures(
        famillyId?: number,
    ): Promise<AssetNaturePaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getAssetNatures(
            famillyId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<AssetNaturePaginationResult>(_response, false, []);
    }

    /**
     * Get asset families
     * @return OK
     */
    async getAssetFamilies(): Promise<AssetFamilyPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getAssetFamilies();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<AssetFamilyPaginationResult>(_response, false, []);
    }
}
